// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Components
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import ContractsTable from '@/app/modules/contracts/components/tables/ContractsTable';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
// Common
import getInitialValueForRowSelected from '@/common-utils/components/renders/dataTable/utils/GetInitialValueForRowSelected';
// Lang
import { nsBeneficiaries } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.merchantAccountId
 * @param root0.beneficiary
 * @param root0.onSubmit
 * @param root0.isSubmitting
 * @returns {JSX} ModalAssociateContracts
 */
function ModalAssociateContracts({
    isOpen,
    setIsOpen,
    merchantAccountId,
    beneficiary,
    onSubmit,
    isSubmitting
}) {

    // State
    const [selectedContracts, setSelectedContracts] = useState(getInitialValueForRowSelected());

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-6xl'>
                <HeaderTitle
                    title='modal.associate_contract.title'
                    namespace={nsBeneficiaries}
                    data={{ benefeciary: beneficiary?.name }}
                />
                <ModalBody className='modal-max-height overflow-auto'>
                    <ContractsTable
                        customQuery={{
                            filters: [
                                {
                                    key: 'excludeContractsFromBeneficiaryUuid',
                                    value: beneficiary.id,
                                    hidden: true
                                },
                                {
                                    key: 'remote_configuration',
                                    value: true,
                                    hidden: true
                                }
                            ]
                        }}
                        rowsSelected={selectedContracts}
                        setRowsSelected={setSelectedContracts}
                        merchantAccountId={merchantAccountId}
                    />
                </ModalBody>
                <FooterForm
                    onSubmit={() => {
                        const contractsProfileUuids = [...beneficiary.contractsIds, ...Object.keys(selectedContracts.rowIds)];
                        onSubmit(contractsProfileUuids);
                    }}
                    isSubmitting={isSubmitting}
                    isSubmitDisabled={!Object.keys(selectedContracts.rowIds).length}
                />
            </ModalContent>
        </Modal>
    );
}

ModalAssociateContracts.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    merchantAccountId: PropTypes.string.isRequired,
    beneficiary: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        contractsIds: PropTypes.array
    }).isRequired,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};
export default ModalAssociateContracts;